import { createStore } from "redux";
import { rootReducer } from "./root-reducer";

const reduxDev = window?.["__REDUX_DEVTOOLS_EXTENSION__"];

/**
 * @type {import("redux").Store<ReturnType<typeof rootReducer>>}
 */
const store = createStore(rootReducer, reduxDev?.());
const { getState, subscribe, dispatch } = store;

export { store, getState, subscribe, dispatch };
